import {
  benefitLabel,
  categoryHasData,
  formatMedicalField,
  MEDICAL_BENEFIT_FIELDS,
  type MedicalBenefits,
} from "../benefitDetailFormat";
import { buildSection, DetailTable, EmptyDetail, type DetailSection } from "./detailPrimitives";

// health / dental / vision — one section per non-empty category, rows from
// MEDICAL_BENEFIT_FIELDS (empty fields dropped), category description as note.
export function MedicalBenefitBlock({ benefits }: { benefits: MedicalBenefits }) {
  const sections = Object.entries(benefits || {})
    .filter(([, category]) => categoryHasData(category))
    .map(([categoryKey, category]) =>
      buildSection(
        benefitLabel(categoryKey),
        MEDICAL_BENEFIT_FIELDS.map((field) => ({
          label: field.label,
          value: formatMedicalField(category[field.accessor], field.format),
        })),
        category.description || undefined,
      ),
    )
    .filter(Boolean) as DetailSection[];

  if (sections.length === 0) return <EmptyDetail />;
  return <DetailTable sections={sections} />;
}
